import MailIcon from "@mui/icons-material/Mail";
import { IconButton } from "@mui/material";
import Badge from "@mui/material/Badge";
import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../Auth";
import ostertalerImage from "../../assets/Ostertaler.png";
import AccountMenu from "../UI/AccountMenu";
import Button from "../UI/Button";

const Header: React.FC = () => {
  const auth = useAuthContext();

  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav className="relative w-full flex items-center justify-between py-4 mb-10 bg-gray-100 text-gray-500 hover:text-gray-700 focus:text-gray-700 shadow-lg navbar navbar-expand-lg navbar-light">
      <div className="container-fluid w-full flex flex-wrap items-center justify-between px-6">
        <button className="navbar-toggler text-gray-500 border-0 hover:shadow-none hover:no-underline py-2 px-2.5 bg-transparent focus:outline-none focus:ring-0 focus:shadow-none focus:no-underline"
          type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bars"
            className="w-6" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
            <path fill="currentColor"
              d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z">
            </path>
          </svg>
        </button>
        <div className="collapse navbar-collapse flex-grow items-center" id="navbarSupportedContent">
          <img src={ostertalerImage} alt="logo" style={{ height: "42px" }}/>
          <ul className="navbar-nav flex flex-col pl-0 list-style-none mr-auto">
            <li className="nav-item p-2">
              <Link className="nav-link text-gray-500 hover:text-gray-700 focus:text-gray-700 p-0" to="/belegung">
                Belegung
              </Link>
            </li>
            {!auth.isAdmin() && (
            <li className="nav-item p-2">
              <Link className="nav-link text-gray-500 hover:text-gray-700 focus:text-gray-700 p-0" to="/buchung">
                Buchen
              </Link>
            </li>)}
            <li className="nav-item p-2">
              <Link className="nav-link text-gray-500 hover:text-gray-700 focus:text-gray-700 p-0" to="/meinebuchung">
                Meine Buchungen
              </Link>
            </li>
          </ul>

        </div>
      </div>
      <div style={{height:"100%"}} className="px-6 self-start">
      {auth.isLoggedIn() && (
            <div className="flex items-center relative">
              {auth.isAdmin() && auth.countIncomingBookings > 0 && (
                <IconButton component={Link} to="/buchung/status" aria-label="cart">
                  <Badge badgeContent={auth.countIncomingBookings} color="primary">
                    <MailIcon color="action" />
                  </Badge>
                </IconButton>
              )}
              <AccountMenu></AccountMenu>
            </div>
          )}
          {!auth.isLoggedIn() && location.pathname !== "/login" && (
            <Button onClick={() => navigate("/login")}>Login</Button>
          )}
      </div>
    </nav>
  );
};

export default Header;
